<template>
  <TextField
    inputId="fp-voucher-webview-url"
    name="voucher_webview"
    :label="t('sites.singleSite.financialConfig.cashlessPay.form.freedomPay.voucherWebviewURL')"
    :placeholder="
      t('sites.singleSite.financialConfig.cashlessPay.form.freedomPay.voucherWebviewURLPlaceholder')
    "
    :required="editCashlessPay"
    :disabled="!editCashlessPay"
  />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { storeToRefs } from 'pinia';
import { useFinancialConfigStore } from '../../../../../../../routes';

// Set localization
const { t } = useI18n();

// Set financial config store
const fConfigStore = useFinancialConfigStore();
const { editCashlessPay } = storeToRefs(fConfigStore);
</script>
